const resultsCurrentQuestionsReducer = (state = {}, action) => {
    switch (action.type) {
      case "SET_RESULTS_CURRENT_QUESTIONS":
        return action.payload;
      default:
        return state;
    }
  }
  export default resultsCurrentQuestionsReducer;